import Input from "../../../../../../../../components/FormikForm/Input";
import Button from "../../../../../../../../components/Button";
import { setToZeroTimeZone, inputDateTimeLocal, dateSpliter } from "../../../../../../../../helpers/dates-hanlder";
import WaitingListFields from "../WaitingListFields";
import StyledCheckbox from "../StyledCheckbox";
import { Container, CheckboxLabel, CheckboxText, SummaryWrapper, SummaryText } from "./styles";

interface CloseSubscriptionsProps {
  values: any;
  errors: any;
  touched: any;
  handleChange: (e: any) => void;
  handleBlur: (e: any) => void;
  setFieldValue: (field: string, value: any) => void;
  closeNow: boolean;
  setCloseNow: (value: boolean) => void;
  showSummaryOnly?: boolean;
  onEditScheduledClosing?: () => void;
  onCancelScheduledClosing?: () => void;
}

const CloseSubscriptions = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
  closeNow,
  setCloseNow,
  showSummaryOnly = false,
  onEditScheduledClosing,
  onCancelScheduledClosing
}: CloseSubscriptionsProps) => {
  // Handler para convertir fecha local a UTC antes de guardar
  const handleDateChange = (fieldName: string) => (e: any) => {
    e.stopPropagation();
    const localDateTime = e.target.value;
    if (localDateTime) {
      const utcDateTime = setToZeroTimeZone(localDateTime);
      setFieldValue(fieldName, utcDateTime);
    } else {
      setFieldValue(fieldName, '');
    }
  };

  // Convertir fechas UTC a local para mostrar en los inputs
  const getLocalDateTimeValue = (utcDate: string | null) => {
    if (!utcDate) return '';
    try {
      return inputDateTimeLocal(utcDate);
    } catch (error) {
      console.error('Error converting UTC to local:', error);
      return '';
    }
  };

  // Generar texto explicativo basado en las opciones seleccionadas
  const getSummaryText = () => {
    let text = '';

    // Evaluar cierre
    if (closeNow) {
      text += 'Las inscripciones se <strong>cerrarán inmediatamente</strong> al guardar los cambios';
    } else if (values?.subscriptions_closing_date) {
      const closingDate = dateSpliter(values.subscriptions_closing_date);
      text += `Las inscripciones se cerrarán el <strong>${closingDate.day.number} de ${closingDate.month.name.large} del ${closingDate.year} a las ${closingDate.hours}:${closingDate.minutes}</strong>`;
    } else {
      text += 'Debe indicar una <strong>fecha de cierre</strong> para programar el cierre de inscripciones';
    }

    // Evaluar lista de espera
    if (values?.waiting_list_external_url) {
      text += '. Los usuarios serán redirigidos a la <strong>lista de espera</strong>';
    }

    text += '.';
    return text;
  };

  // Generar texto específico para cuando showSummaryOnly es true
  const getSummaryOnlyText = () => {
    let text = '<strong>Actualmente, las inscripciones están abiertas</strong>. ';

    if (values?.subscriptions_closing_date) {
      const closingDate = dateSpliter(values.subscriptions_closing_date);
      text += `Se cerraran el <strong>${closingDate.day.number} de ${closingDate.month.name.large} de ${closingDate.year} a las ${closingDate.hours}:${closingDate.minutes}</strong>`;
    }

    if (values?.waiting_list_external_url) {
      text += '. Después del cierre, las personas serán redirigidas al link que configuraste.';
    } else {
      text += '.';
    }

    return text;
  };

  const summaryText = showSummaryOnly ? getSummaryOnlyText() : getSummaryText();

  if (showSummaryOnly) {
    return (
      <Container>
        <SummaryWrapper style={{ margin: 0 }}>
          <SummaryText dangerouslySetInnerHTML={{ __html: summaryText }} />
        </SummaryWrapper>

        <div style={{ display: 'flex', gap: '12px', marginTop: '16px', flexWrap: 'wrap' }}>
          <Button
            options={{ type: "outline", skin: "purple", size: "md" }}
            onClick={() => {
              onEditScheduledClosing?.();
            }}
          >
            Editar fechas
          </Button>

          <Button
            options={{ type: "filled", skin: "purple", size: "md" }}
            onClick={() => {
              onCancelScheduledClosing?.();
            }}
          >
            Cancelar y dejar abiertas
          </Button>
        </div>
      </Container>
    );
  }

  return (
    <Container>
      <CheckboxLabel checked={closeNow}>
        <StyledCheckbox
          id="close-now"
          checked={closeNow}
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => {
            setCloseNow(e.target.checked);
            setFieldValue('closeNow', e.target.checked);
            if (e.target.checked) {
              setFieldValue('subscriptions_closing_date', '');
            }
          }}
        />
        <CheckboxText checked={closeNow} htmlFor="close-now">
          Cerrar ahora
        </CheckboxText>
      </CheckboxLabel>

      <div style={{ height: 16 }} />

      <div onClick={(e) => e.stopPropagation()}>
        <Input
          name="subscriptions_closing_date"
          type="datetime-local"
          error={errors?.subscriptions_closing_date}
          touched={touched?.subscriptions_closing_date}
          value={getLocalDateTimeValue(values?.subscriptions_closing_date)}
          onChange={handleDateChange('subscriptions_closing_date')}
          onBlur={handleBlur}
          disabled={closeNow}
          options={{
            explainText: "Elegí día y horario para cerrar las inscripciones.",
            label: "Indicar fecha de cierre",
            marginBottom: 0
          }}
        />
      </div>

      <div style={{ height: 24 }} />

      <WaitingListFields
        values={values}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
        handleBlur={handleBlur}
      />

      <SummaryWrapper>
        <SummaryText dangerouslySetInnerHTML={{ __html: summaryText }} />
      </SummaryWrapper>
    </Container>
  );
};

export default CloseSubscriptions;

